angular.module('unica_invitation_group.invitation_group_controllers', [])

.controller('InvitationGroupBasicController',
	function(
		$rootScope, $scope, $stateParams,
		InvitationGroupListService
	) {

	$scope.forms = {};

	$scope.event_id = $stateParams.event_id;

	$scope.invitationGroupData = { };

	$scope.resetInvitationGroupData = function()
	{
		$scope.invitationGroupData = { };
	};

	$scope.getInvitationGroup = function(id)
	{
		$rootScope.showLoader();

		InvitationGroupListService
			.get( id )
			.then(function(data) {
				$rootScope.hideLoader();

				console.log( data );
				if ( data ) {
					$scope.invitationGroupData = data;
				}
			});
	};

});